import {Box, Stack} from "@mui/material";
import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";
import {PAGE_SHELL_BORDER} from "../layout/PageShell";
import WelcomeMessage from "./WelcomeMessage";
import MyApps from "./MyApps";
import Support from "./Support";
import {MobileSidebarButton} from "../layout/leftSidebar/MobileSidebar";

const HomePage = () => {
    useTrackScreenVisit("Home");

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                minHeight: "calc(100dvh - var(--banner-offset, 0px))",
                boxSizing: "border-box",
                px: {xs: 0, md: 2},
                pb: {xs: 0, md: 2},
                pt: {xs: 0, md: 2},
            }}
        >
            <Box
                sx={{
                    display: {xs: "flex", md: "none"},
                    height: 56,
                    px: 1,
                    alignItems: "center",
                    flexShrink: 0,
                }}
            >
                <MobileSidebarButton/>
            </Box>
            <Box
                sx={{
                    flex: 1,
                    bgcolor: "#fff",
                    borderRadius: {xs: 0, md: 4},
                    border: {xs: 0, md: PAGE_SHELL_BORDER},
                    borderTop: PAGE_SHELL_BORDER,
                    boxSizing: "border-box",
                    p: {xs: 3, md: 4},
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        maxWidth: {xs: "100%", md: "1200px"},
                        width: "100%",
                        mx: "auto",
                    }}
                >
                    <Stack gap={4}>
                        <WelcomeMessage/>
                        <MyApps/>
                        <Support/>
                    </Stack>
                </Box>
            </Box>
        </Box>
    );
};

export default HomePage;
